<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <router-link to="/Car/RewardsApply">
          <el-button type="primary" size="mini">作业车辆管理奖惩申请审批</el-button>
        </router-link>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <!-- <div class="list-title">
      <el-row>
        <el-col class="item-select" :span="5">
          <label>用车类型：</label>
          <el-select size="mini" v-model="filterType" placeholder="请选择">
            <el-option v-for="item in useCarTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索项目编号/立项编号/项目名/负责人"></el-input>
        </el-col>
      </el-row>
    </div> -->

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批(已取消、已拒绝)</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>

      <el-table-column label="车辆信息">
        <template slot-scope="scope">
          {{ scope.row.car.xh+' - '+ scope.row.car.plateNo+' - '+scope.row.car.type }}
        </template>
      </el-table-column>
      <el-table-column prop="sqs" label="上期数" width="70" align="center">
      </el-table-column>
      <el-table-column prop="bqs" label="本期数" width="70" align="center">
      </el-table-column>
      <el-table-column prop="total" label="奖惩金额(元)" width="80" align="center">
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>
          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id && scope.row.flow.status!='审批通过'">
            <span
              v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消')">
              <el-tooltip class="item" effect="dark" content="修改车辆使用审批" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId, scope.row.projectId)"></i>
              </el-tooltip>
              <cancel-flow :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
            </span>
          </span>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import Role from '@/Mixins/role'
  import CancelFlow from '@/components/CancelFlow'

  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        filterKey: "",
        filterType: 0,

        // 款项支付所属类型
        useCarTypeList: [],
        listType: 0,

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: '',
          remark: '',
        },
      }
    },
    created() {},
    mounted() {
      // console.log(this.organization.length > 0)

      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
      }

    },
    methods: {
      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: '/Car/RewardsApply',
          query: {
            applyId: applyId,
          }
        })
      },
      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        // console.log(this.filterName)
        if (this.filterType != 0 || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]

            // 筛选支付类别
            let _filterType = true
            if (this.filterType != 0 && (!_project.useCarTypeId || this.filterType != _project.useCarTypeId)) {
              _filterType = false
            }

            // 筛选搜索结果
            if (_filterType) {
              if ((_project.projectName && _project.projectName.toLowerCase().indexOf(this.filterKey.toLowerCase()) !=
                  -1) || (_project.htmc && _project.htmc.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) ||
                (_project.name && _project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) || _project
                .flow
                .creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_project)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/car/apply/list', {
          'depId': this.depId,
          'types': '89',
          'status': this.listType
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      'depId'() {
        this.currentPage = 1
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },

      listType() {
        this.currentPage = 1
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/car/rewardsList.vue